import { render, staticRenderFns } from "./CarterasList.vue?vue&type=template&id=a52fe104&scoped=true&"
import script from "./CarterasList.vue?vue&type=script&lang=js&"
export * from "./CarterasList.vue?vue&type=script&lang=js&"
import style0 from "./CarterasList.vue?vue&type=style&index=0&id=a52fe104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52fe104",
  null
  
)

export default component.exports